import { DateTimeOptions } from 'vue-i18n';

const locale = window.Hobbii?.storeLocale;

const dateOptions: DateTimeOptions = {
  year: 'numeric',
  month: '2-digit',
  day: '2-digit'
};

const dateTimeFormatter = (options?: DateTimeOptions) => {
  return new Intl.DateTimeFormat(
    locale,
    options || {
      ...dateOptions,
      hour: 'numeric',
      minute: '2-digit'
    }
  );
};

const dateFormatter = (options?: DateTimeOptions) => {
  return new Intl.DateTimeFormat(locale, options || dateOptions);
};

export const dateString = (date: Date | string, options?: DateTimeOptions) => {
  if (!date) return '';
  if (typeof date === 'string') date = new Date(date);

  return dateFormatter(options).format(date);
};

export const dateTimeString = (
  date: Date | string,
  options?: DateTimeOptions
) => {
  if (!date) return '';
  if (typeof date === 'string') date = new Date(date);

  return dateTimeFormatter(options).format(date);
};

export const isoStringAsDate = (input?: string | null) => {
  if (!input) return null;

  const date = new Date(input);

  // Check if the string was successfully parsed
  if (Number.isNaN(date.getTime())) return null;

  return date;
};
